// extracted by mini-css-extract-plugin
module.exports = {"toaster":"style_toaster__3WUZu","toaster__icon__button":"style_toaster__icon__button__1xOoS","times__icon":"style_times__icon__LCm8g"};